module.exports = __webpack_public_path__ + "static/media/Home Page_website-20.1f7a13c4.png";